import { Link } from "react-router-dom"
import { CUSTOM_FK_CONFIG } from "./ForeignKeyComponents"
import { formatRelatedObjectLabel, getRelatedObjectIcon } from "../columnTypeMeta"

// Aggregates every FK_OBJECT custom column value on a task into one cell. Used by
// the My Tasks list, which spans boards and so cannot render each board's custom
// columns individually.
//
// Read-only by design: the values belong to columns on a board the user is not
// currently viewing, so an inline edit target would be ambiguous.
function RelatedObjectsCell({ relatedObjects }) {
    if (!relatedObjects || relatedObjects.length === 0) {
        return <span className="text-muted">--</span>
    }

    return (
        <span className="related-objects-cell">
            {relatedObjects.map((relatedObject, index) => {
                const config = CUSTOM_FK_CONFIG[relatedObject?.model]
                const displayValue = relatedObject?.valueString || "--"

                return (
                    <span className="related-object-item" key={`${relatedObject?.columnId}-${index}`}>
                        {/* Icon rather than the column title, so several related objects stay
                            compact. The title moves to the tooltip -- same `title` attribute the
                            board's own column-header badge uses. */}
                        <span className="related-object-icon text-muted" title={formatRelatedObjectLabel(relatedObject)}>
                            <i className={`fa ${getRelatedObjectIcon(relatedObject?.model)}`} aria-hidden="true" />
                        </span>
                        {/* Truncated to one line -- the full value is the tooltip, so several
                            related objects stay readable without stretching the column. */}
                        {config ? (
                            <Link className="related-object-value" to={config.getLink(relatedObject)} title={displayValue}>
                                {displayValue}
                            </Link>
                        ) : (
                            // Same fallback as renderCustomColumn: a model with no link
                            // config still shows its value, just not as a link.
                            <span className="related-object-value" title={displayValue}>{displayValue}</span>
                        )}
                    </span>
                )
            })}
        </span>
    )
}

export default RelatedObjectsCell
